import pb from './pocketbase.js';
import { toast } from 'react-toastify';

/**
 * Service pour gérer les notifications de chat
 */
class ChatNotificationService {
  constructor() {
    this.currentUser = null;
    this.lastNotificationTime = 0;
    this.notificationCooldown = 2000; // 2 secondes entre les notifications
    // URL d'un son de notification discret
    this.notificationSound = new Audio('https://assets.mixkit.co/active_storage/sfx/2358/2358-preview.mp3');
  }

  /**
   * Envoie une notification push pour un nouveau message de chat
   * @param {Object} messageRecord - L'enregistrement du message
   * @param {Object} senderRecord - L'enregistrement de l'expéditeur
   */
  async sendChatNotification(messageRecord, senderRecord) {
    try {
      // Éviter de se notifier soi-même
      if (this.currentUser && messageRecord.sender === this.currentUser.id) {
        return;
      }

      // Éviter le spam de notifications
      const now = Date.now();
      if (now - this.lastNotificationTime < this.notificationCooldown) {
        return;
      }
      this.lastNotificationTime = now;

      // Déterminer qui est l'expéditeur
      const senderName = senderRecord?.name || senderRecord?.username || senderRecord?.email || 'Utilisateur';
      const bodyText = `Nouveau message de ${senderName}`;

      // 1. Notification Sonore
      try {
        this.notificationSound.play().catch(e => console.log('Audio play blocked by browser'));
      } catch (e) {
        console.error('Erreur lecture son:', e);
      }

      // 2. Notification Toast (In-App)
      toast.info(bodyText, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        icon: "💬"
      });

      // 3. Notification Browser (Push)
      if ('Notification' in window && Notification.permission === 'granted') {
        const notification = new Notification('💬 Couleur Sirène', {
          body: bodyText,
          icon: '/faviconx.ico',
          badge: '/faviconx.ico',
          tag: 'chat-message',
          requireInteraction: true
        });

        notification.onclick = () => {
          window.focus();
          if (window.location.pathname !== '/admin') {
            window.open('/admin', '_blank');
          }
          notification.close();
        };
      } else if ('Notification' in window && Notification.permission !== 'denied') {
        // Demander la permission si pas encore fait
        Notification.requestPermission();
      }
      
      console.log('🔔 Notifications envoyées pour le message de', senderName);
      
    } catch (error) {
      console.error('Erreur lors de l\'envoi de la notification chat:', error);
    }
  }

  /**
   * Initialise l'écoute des nouveaux messages de chat en temps réel
   * @param {Object} user - L'utilisateur actuel pour le filtrage
   */
  async initializeChatNotifications(user) {
    this.currentUser = user;
    try {
      // Demander la permission de notification au démarrage
      if ('Notification' in window && Notification.permission === 'default') {
        Notification.requestPermission();
      }

      // Écouter les nouveaux messages de chat
      await pb.collection('chat_messages').subscribe('*', async (e) => {
        if (e.action === 'create') {
          try {
            // On récupère les détails de l'expéditeur pour le nom
            // Note: expand: 'sender' pourrait être utilisé si Pocketbase le renvoie dans l'event
            const senderRecord = await pb.collection('users').getOne(e.record.sender);
            await this.sendChatNotification(e.record, senderRecord);
          } catch (error) {
            console.error('Erreur détails notification:', error);
          }
        }
      });
      
      console.log('🎧 Service de notifications global activé pour:', user?.email);
    } catch (error) {
      console.error('Erreur initialisation notifications:', error);
    }
  }

  /**
   * Arrête l'écoute des notifications de chat
   */
  async stopChatNotifications() {
    try {
      await pb.collection('chat_messages').unsubscribe();
      this.currentUser = null;
      console.log('🔇 Service de notifications global arrêté');
    } catch (error) {
      console.error('Erreur arrêt notifications:', error);
    }
  }
}

export default new ChatNotificationService();

